export enum ActionStatuses {
  approved = 'approved',
  rejected = 'rejected',
  open = 'open',
  openAndPaid = 'openAndPaid',
}
